import { memo } from "react";
import { type NodeProps, Handle } from "@xyflow/react";
import cn from "classnames";
import Icon from "~/components/shared/Icon";
import BaseNode from "~/components/Playground/Node/BaseNode";
import * as HoverCard from "~/components/Playground/HoverCard";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { Build } from "~/components/build/Show/lib/types";
import { BuildNode } from "~/components/Playground/Node/BuildNode";

const RootNodeIcon = () => (
  <div
    aria-hidden={true}
    className="flex h-7 w-7 items-center justify-center rounded-md bg-green-700"
  >
    <Icon className="h-4 w-4 text-white" icon="heroicons/solid/play" />
  </div>
);

function RootNode(props: NodeProps) {
  const { build } = useBuild({ strict: false });

  if (build) {
    return <BuildNode {...props} type="build" data={build as Build & Record<string, unknown>} />;
  }

  return (
    <HoverCard.Trigger
      className="group"
      payload={{
        id: props.id,
        content: (
          <HoverCard.Content id={props.id} label="Trigger event">
            You can configure specific events to run a pipeline, such as when a new commit is
            pushed, via an API webhook, on a schedule, manually via the UI or CLI, and more.
          </HoverCard.Content>
        ),
      }}
    >
      <BaseNode
        {...props}
        label="Trigger event"
        icon={<RootNodeIcon />}
        className="cursor-help group-hover:bg-green-100 group-focus:bg-green-100"
      />
      {props.sourcePosition && (
        <Handle
          type="source"
          position={props.sourcePosition}
          isConnectable={props.isConnectable}
          className={cn({ "opacity-0": !props.isConnectable })}
        />
      )}
    </HoverCard.Trigger>
  );
}

export default memo(RootNode);
